<template>
    <div style="position: relative;">
        <b-navbar type="light" toggleable="sm" class="shadow-sm module-navbar">
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
            <b-collapse id="nav_dropdown_collapse" is-nav>
                <b-navbar-nav v-if="isLoading">
                    <b-nav-item disabled>
                        <i class="cus-hourglass"></i>Saving...
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav v-else-if="isContactDashboard">
                    <b-nav-item v-if="_hasAccess('contact.person.create')" @click="showNewContact()">
                        <i class="cus-add"></i>New Contact
                    </b-nav-item>
                    <b-nav-item v-if="_hasAccess('contact.company.create')" @click="showNewCompany()">
                        <i class="cus-add"></i>New Company
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav v-else-if="editMode">
                    <b-nav-item @click="saveContact()">
                        <i class="cus-disk"></i>Save + Done
                    </b-nav-item>
                    <b-nav-item @click="cancelEdit()">
                        <i class="cus-cancel"></i>Cancel
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav v-else>
                    <b-nav-item v-if="isCompany && _hasAccess('contact.company.update')" @click="editContact()">
                        <i class="cus-page-white-edit"></i>Edit Company
                    </b-nav-item>
                    <b-nav-item v-else-if="!isCompany && _hasAccess('contact.person.update')" @click="editContact()">
                        <i class="cus-page-white-edit"></i>Edit Contact
                    </b-nav-item>
                    <b-nav-item v-if="isCompany && _hasAccess('contact.company.delete')" @click="showDelete()">
                        <i class="cus-delete"></i>Delete Company
                    </b-nav-item>
                    <b-nav-item v-else-if="!isCompany && _hasAccess('contact.person.delete')" @click="showDelete()">
                        <i class="cus-delete"></i>Delete Contact
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
            <b-navbar-nav class="ml-auto">
                <b-nav-form
                    @click="$refs['select-contact'].focus()"
                    @contextmenu="rightClickHandler"
                    class="ml-auto"
                >
                    <vet-select-contact
                        ref="select-contact"
                        :key="'search' + searchContactKey"
                        :focus-onload="isContactDashboard"
                        class="mr-sm-2 w-100 search nav-search show-actions"
                    />
                </b-nav-form>
            </b-navbar-nav>
        </b-navbar>

        <new-contact ref="newContactModal" @saved="onSuccess"></new-contact>
        <new-company ref="newCompanyModal" @saved="onSuccess"></new-company>
        <delete-contact
            ref="contactDelete"
            @succeed="redirectToDashboard()"
            lazy
        />

        <router-view></router-view>
    </div>
</template>
<script>
import NewContact from "@/components/contact-actor/new-modal.vue";
import NewCompany from "@/components/contact-company/new-modal.vue";
import vetSelectContact from "@/module/commons/vet-select-contact";
import ContactServices from "@/services/contacts";

export default {
    components: {
        NewContact,
        NewCompany,
        vetSelectContact,
        DeleteContact: () =>
            import("@/components/contacts/contact-delete-modal")
    },
    data() {
        return {
            resources: {},
            searchContactKey: 0,
            isLoading: false
        };
    },
    computed: {
        isContactDashboard() {
            return this.$route.name === "contact_dashboard";
        },
        isCompany() {
            return this.$route.name === "contact_company";
        },
        contactData() {
            return this.$store.getters["contact/contactDetails"];
        },
        contactEncodedId() {
            return this.$store.state.contact.contactDetails.encoded_id;
        },
        editMode() {
            return this.$store.state.contact.editMode;
        },
        isValidated() {
            return this.$store.getters["contact/isValidated"];
        }
    },
    created() {},
    mounted() {},
    watch: {
        "$route.name"() {
            this.searchContactKey++;
        }
    },
    methods: {
        showNewContact() {
            this.$refs.newContactModal.open();
        },
        showNewCompany() {
            this.$refs.newCompanyModal.open();
        },
        onSuccess(details) {
            if (details.contact_type == "business") {
                this.$router.push(`/contact/company/${details.encoded_id}`);
            } else {
                this.$router.push(`/contact/profile/${details.encoded_id}`);
            }
        },
        rightClickHandler(e) {
            if (e.which === 3) {
                this.$refs["select-contact"].focus();
            }
        },
        editContact() {
            this.$store.commit("contact/setEditMode", true);
        },
        showDelete() {
            let contact = _.clone(this.contactData);
            contact.isActor = !this.isCompany;
            this.$refs.contactDelete.open(contact);
        },
        redirectToDashboard() {
            this.$router.replace("/contact/dashboard");
        },
        cancelEdit() {
            this.$store.commit("contact/setEditMode", false);
            if (this.isCompany) {
                this.$store.dispatch("contact/getContactCompanyDetails", {
                    id: this.contactEncodedId
                });
            } else {
                this.$store.dispatch("contact/getContactActorDetails", {
                    id: this.contactEncodedId
                });
            }
        },
        async saveContact() {
            let self = this;

            if (!self.isValidated) {
                return;
            }

            let contactEditDetails = this.$store.state.contact
                .contactEditDetails;

            self.isLoading = true;

            if (this.isCompany) {
                let params = {
                    id: contactEditDetails.id,
                    name: contactEditDetails.name,
                    phone: contactEditDetails.phone,
                    phone_country_code: contactEditDetails.phone_country_code,
                    fax: contactEditDetails.fax,
                    fax_country_code: contactEditDetails.fax_country_code,
                    website: contactEditDetails.website,
                    email: contactEditDetails.email,
                    address: contactEditDetails.address,
                    zipcode: contactEditDetails.zipcode,
                    city: contactEditDetails.city,
                    county: contactEditDetails.county,
                    state: contactEditDetails.state,
                    country: contactEditDetails.country,
                    account_no: contactEditDetails.account_no
                };

                ContactServices.updateContactCompany(params)
                    .then(response => {
                        if (response.message && response.message.code === 200) {
                            self._message("Changes saved", "success");
                            this.$store.commit("contact/setEditMode", false);
                            this.$store.dispatch(
                                "contact/getContactCompanyDetails",
                                {
                                    id: this.contactEncodedId
                                }
                            );
                        }
                    })
                    .catch(e => {
                        this._message(
                            "Error : unable to edit this contact.",
                            "danger"
                        );
                        console.error(e);
                    })
                    .finally(() => (self.isLoading = false));
            } else {
                let params = {
                    id: contactEditDetails.id,
                    salutation: contactEditDetails.salutation,
                    firstname: contactEditDetails.firstname,
                    lastname: contactEditDetails.lastname,
                    title: contactEditDetails.title,
                    address: contactEditDetails.address,
                    zipcode: contactEditDetails.zipcode,
                    city: contactEditDetails.city,
                    county: contactEditDetails.county,
                    state: contactEditDetails.state,
                    country: contactEditDetails.country,
                    mobile: contactEditDetails.mobile,
                    mobile_country_code: contactEditDetails.mobile_country_code,
                    work: contactEditDetails.work,
                    work_country_code: contactEditDetails.work_country_code,
                    fax: contactEditDetails.fax,
                    fax_country_code: contactEditDetails.fax_country_code,
                    email: contactEditDetails.email
                };
                ContactServices.updateContactActor(params)
                    .then(response => {
                        if (response.message && response.message.code === 200) {
                            self._message("Changes saved", "success");
                            this.$store.commit("contact/setEditMode", false);
                            this.$store.dispatch(
                                "contact/getContactActorDetails",
                                {
                                    id: this.contactEncodedId
                                }
                            );
                        }
                    })
                    .catch(e => {
                        this._message(
                            "Error : unable to edit this contact.",
                            "danger"
                        );
                        console.error(e);
                    })
                    .finally(() => (self.isLoading = false));
            }
        }
    }
};
</script>
